import 'bootstrap';

import {createApp} from "vue";

import JobList from "./components/JobList.vue";
import Search from "./components/Search.vue";
import GeaBox from "./components/GeaBox.vue";
import List from "./components/List.vue";

const app = createApp({});

app.component('JobList', JobList);
app.component('SearchJob', Search);
app.component('GeaBox', GeaBox);
app.component('List', List);

app.mount('.job-list-module');
